<template>
  <b-card class="mb-5">
    <b-row class="mb-2">
      <b-col md="10">
        <h3>{{ $route.name }}</h3>
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
      </b-col>
      <b-col md="2 mt-4">
        <b-button variant="primary" class="float-right btn-custom" :to="'items/create'"
          ><font-awesome-icon icon="plus"
        /></b-button>
      </b-col>
    </b-row>
    <div class="border-bottom mb-3"></div>
    <b-form v-on:submit.prevent="doFilter">
      <b-row class="mb-3 mt-3">
        <b-col md="6 mb-3" class="d-flex">
          <b-form-input
            v-model="tableFilter.search"
            customQueryParamName="search"
            placeholder="Search"
            class="border-radius font-weight-bold"
            style="font-size: 20px; color: #3d3d3d"
          />
          <button type="submit" class="ml-2 btn btn-primary float-right border-radius" id="btn-search">
            <font-awesome-icon icon="search" />
          </button>

          <button
            @click="clearFilter()"
            class="ml-0 btn btn-outline-danger float-right border-radius ml-2"
            id="btn-search"
          >
            clear
          </button>
         
        </b-col>
       
        <!-- <b-button variant="light" style="margin-left:-70px!important; padding-bottom:30px!important;" disabled><font-awesome-icon icon="spinner" spin v-if="isLoadingBranch" />
            </b-button> -->
        <b-col md="3">
          <!-- button filter -->
          <!-- end button -->

          <!-- button clear filter -->
          
          <!-- end button -->
        </b-col>
      </b-row>
    </b-form>
    <paginated-table
      ref="dataTable"
      :can-show="true"
      :can-delete="true"
      :can-edit="true"
      style="white-space: pre-line;"

      :can-approve="false"
      :can-reject="false"
      :data-url="apiUrl.itemList"
      :data-key="dataKey"
      :data-columns="columns"
      :data-params="['search', 'item_id', 'item_name']"

    >
    </paginated-table>
  </b-card>
</template>
<script>
import PaginatedTable from '@/components/PaginatedTable';
export default {
  name: 'items-index',
  components: {
    PaginatedTable,
  },
  data() {
    return {
      isLoadingBranch: false,
      dataKey: 'item_list',
      apiUrl: {
        itemList: window.AppConfig.apiUrl + 'item-list',
      },
      columns: [
        {
          key: 'itemId',
          label: 'Item ID ',
          sortable: true,
        },

        {
          key: 'name',
          label: 'Name',
          sortable: true,
          class: 'w-25',
          style:"white-space: pre-line;"
        },

        {
          key: 'itemCategory.name',
          label: 'Category',
          sortable: true,
        },
        {
          key: 'normalPrice',
          label: 'Normal Price',
          sortable: true,
        },
        {
          key: 'corporatePrice',
          label: 'Corporate Price',
          sortable: true,
        },
        {
          key: 'itemUnit.name',
          label: 'Unit',
          sortable: true,
        },

        {
          key: 'actions',
          label: '',
        },
      ],

      tableFilter: {
        item_id: this.$route.query.item_id,
        // name: null,
        search: this.$route.query.search,
        // name: null
      },
    };
  },
  watch: {
    // 'tableFilter.search'() {
    //   this.doFilter();
    // },
    // 'tableFilter.name' () {
    //     this.doFilter()
    // },
    'tableFilter.item_id' () {
        this.doFilter()
    }
  },
  mounted() {},

  methods: {
    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD HH:mm');
      } else {
        return '-';
      }
    },
    doFilter() {
      this.tableFilter.item_id = this.tableFilter.item_id,
      this.tableFilter.search = this.tableFilter.search,
        this.$refs.dataTable.doFilter(this.tableFilter);
    },
    reset() {
      this.tableFilter.item_name = null;
      this.tableFilter.item_id = null;
      this.$refs.dataTable.doFilter(this.tableFilter);
    },
    getStatusColor(val) {
      switch (val) {
        case 'Customer':
          return 'info';
          // eslint-disable-next-line no-unreachable
          break;
      }
    },

    clearFilter() {
      this.tableFilter.item_id = null;
      this.tableFilter.search = null;
      this.tableFilter.number = null;
      this.tableFilter.date = null;
      this.$refs.dataTable.doFilter(this.tableFilter);
    },
  },
};
</script>

<style scoped>
.breakline {
  white-space: pre-line
}
</style>
